module.exports = __webpack_public_path__ + "img/search.7bceee51.svg";